import React from 'react';
import { Alert, Button } from '@edgebox/react-components';
import { PagedSiteList } from '../../Shared/PagedSiteList';
import { IAppContextProp, withAppContext } from '../../../common/contexts/AppContext';
import { propertyChangeReload } from '../../../common/helpers/propertyChangeReload';
import { RegisterMultipleSites } from './RegisterMultipleSites';
import { UserRoleGate } from '../../../common/components/UserRoleGate';
import { CustomerRole } from '@edgebox/data-definitions';
import { ensureProjectOfType } from '../../RouterHelper';
import { SiteApplicationType } from '@edgebox/sync-core-data-definitions';

interface IProps extends IAppContextProp, React.JSX.IntrinsicAttributes {}

class SiteListClass extends React.Component<IProps, { registerMultiple?: boolean }> {
  async load() {
    return {};
  }

  render() {
    const registerMultiple = !!this.state?.registerMultiple;

    return (
      <>
        <PagedSiteList
          backend={true}
          container={false}
          customerId={this.props.appContext.customer?.id}
          forContract={this.props.appContext.contract}
          forProject={this.props.appContext.project}
          message={
            <UserRoleGate allowed={[CustomerRole.Owner, CustomerRole.ManageSites]}>
              {() => (
                <Alert variant="primary" className="hero bg-primary text-white p-3 ps-4">
                  {registerMultiple ? (
                    <>
                      <h3>Register multiple sites at once</h3>
                      <RegisterMultipleSites embedded />
                    </>
                  ) : (
                    <>
                      If you have many sites,{' '}
                      <Button
                        variant="primary"
                        className="hero-cta ps-2 pe-2 pt-1 pb-1 ms-1 me-1"
                        onClick={() => this.setState({ registerMultiple: true })}
                      >
                        Register multiple sites at once
                      </Button>
                    </>
                  )}
                </Alert>
              )}
            </UserRoleGate>
          }
        />
      </>
    );
  }
}

export const SiteList = ensureProjectOfType(
  withAppContext(propertyChangeReload(SiteListClass, (props) => props.appContext.projectKey)),
  SiteApplicationType.Drupal
);
